export const BANNER = "BannerLeaderboard";
export const HOW_IT_WORKS = "HowItWorksLeaderboard";
export const LATEST_SIGNUP = "LatestSignUpLeaderboard";
export const SCORE_BOARD = "ScoreboardLeaderboard";
export const NOTIFICATION = "notification";
export const WINNER = "WinnerLeaderboard";
export const RAFFLE_WINNER = "RaffleWinnerLeaderboard";
export const TERM = "TermsConditionsLeaderboard";
export const ESPORT_TABLE = "EsportComplexTableLeaderboard";
export const LEFT_ESPORT_BOARD = "LeftTablesLeaderboard";
export const RUNNER_WINNER = "RunnerWinnerLeaderboard"
export const ROUNDS_BOARD = "RoundLeaderboard";
export const PARENT_NODE = "LeaderboardComponentContainer";
export const ERROR = "ErrorPageContent";
export const ALL = "ALL";

export const STATUS = {
  UNKNOWN: "UNKNOWN",
  NOT_LAUNCH: "NOT_LAUNCH",
  LAUNCH: "LAUNCH",
  OPT_IN: "OPT_IN",
  LIVE: "LIVE",
  END: "END"
};

export const LAYOUT = {
  [STATUS.LAUNCH]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "TimeOptIn"],
    [HOW_IT_WORKS]: [ALL],
    [LATEST_SIGNUP]: [],
    [SCORE_BOARD]: [],
    [WINNER]: [],
    [RAFFLE_WINNER]: [],
    [TERM]: [ALL]
  },
  [STATUS.OPT_IN]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "JoinNow"],
    [HOW_IT_WORKS]: [ALL],
    [LATEST_SIGNUP]: [ALL],
    [SCORE_BOARD]: [],
    [WINNER]: [],
    [RAFFLE_WINNER]: [],
    [TERM]: [ALL]
  },
  [STATUS.LIVE]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "JoinNow"],
    [HOW_IT_WORKS]: [ALL],
    [LATEST_SIGNUP]: [],
    [SCORE_BOARD]: [ALL],
    [WINNER]: [],
    [RAFFLE_WINNER]: [],
    [TERM]: [ALL]
  },
  [STATUS.END]: {
    [BANNER]: ["Breadcrumb", "OptedInEndContent"],
    [HOW_IT_WORKS]: [],
    [LATEST_SIGNUP]: [],
    [SCORE_BOARD]: [],
    [WINNER]: [ALL],
    [RAFFLE_WINNER]: [ALL],
    [TERM]: []
  }
}

export const LAYOUT_ROUNDS = {
  [STATUS.LAUNCH]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "TimeOptIn"],
    [HOW_IT_WORKS]: [ALL],
    [ESPORT_TABLE]: [],
    [TERM]: [ALL]
  },
  [STATUS.OPT_IN]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "JoinNow"],
    [HOW_IT_WORKS]: [ALL],
    [ESPORT_TABLE]: [ALL],
    [TERM]: [ALL]
  },
  [STATUS.LIVE]: {
    [BANNER]: ["Breadcrumb", "OpenContent", "JoinNow"],
    [HOW_IT_WORKS]: [ALL],
    [ESPORT_TABLE]: [ALL],
    [TERM]: [ALL]
  },
  [STATUS.END]: {
    [BANNER]: ["Breadcrumb", "OptedInEndContent"],
    [HOW_IT_WORKS]: [],
    [ESPORT_TABLE]: [ALL],
    [TERM]: []
  }
}

export const ERROR_PAGE = {
  [BANNER]: ["Breadcrumb", ERROR],
  [HOW_IT_WORKS]: [],
  [LATEST_SIGNUP]: [],
  [SCORE_BOARD]: [],
  [WINNER]: [],
  [RAFFLE_WINNER]: [],
  [ESPORT_TABLE]: [],
  [TERM]: []
}

export const LEFT_TABLE_BOARD = {
  [STATUS.OPT_IN]: ["LatestSignUpLeaderboard"],
  [STATUS.LIVE]: ["ScoreboardLeaderboard"],
  [STATUS.END]: ["WinnerLeaderboard", "RunnerWinnerLeaderboard"]
}

export const BOARD_CODE = {
  SILVER_STAKES_SOCCER: 'SILVERSTAKESSOCCER',
  SILVER_STAKES_BASKETBALL: 'SILVERSTAKESBASKETBALL',
  SILVER_STAKES_ESPORTS : 'SILVERSTAKESESPORTS',
  SILVER_STAKES_ESPORTS_R1 : 'SILVERSTAKESESPORTSR1',
  SILVER_STAKES_ESPORTS_R2 : 'SILVERSTAKESESPORTSR2',
  SILVER_STAKES_ESPORTS_R3 : 'SILVERSTAKESESPORTSR3',
  SILVER_STAKES_ESPORTS_R4 : 'SILVERSTAKESESPORTSR4'
};
export const LIMIT_TOP_NUMBER = {
  EPSPORT_TOTAL_END : 4,
  EPSPORT_ROUND_END: 7,
  DEFAULT: 25
};


// WEBPACK FOOTER //
// ./src/app/components/LeaderboardComponent/Template/types.js